import React, { useEffect, useMemo, useState } from 'react';
import { hoSoSurveyApi } from '../../api/hoSoSurveyApi';
import styles from './HoSoStatusSummary.module.css'
import clsx from "clsx"
const HoSoStatusSummary = ({ onSelectionChanged, refreshCount }) => {
    const [dataSource, setDataSource] = useState([])
    const [selectedId, setSelectedId] = useState(-1);
    useEffect(() => {
        handleReloadStatusSummary();
    }, [refreshCount])
    const handleReloadStatusSummary = async () => {
        const res = await hoSoSurveyApi.SelectStatusSummary();
        if (res.is_success) {
            setDataSource(res.data)
        }
    }
    const total = useMemo(() => {
        return dataSource.map(x => x.so_luong).reduce((a, b) => a + b, 0);
    }, [dataSource])
    return (
        <div className={styles.container}>
            <div key={0} className={clsx(styles.item_container, selectedId == -1 ? styles.selected : "")}
                onClick={() => {
                    setSelectedId(-1);
                    onSelectionChanged(-1);
                }}>
                Tất cả
                <span className={styles.count}>
                    {total}
                </span>
            </div>
            {dataSource.map((x, idx) => {
                return (
                    <div key={idx} className={clsx(styles.item_container, selectedId == x.id ? styles.selected : "")}
                        onClick={() => {
                            setSelectedId(x.id)
                            onSelectionChanged(x.id);
                        }}
                    >
                        {x.name}
                        <span className={styles.count}>
                            {x.so_luong}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default HoSoStatusSummary;